export const categoria = [
  {
    nombre: "Cajones y Cultivos",
    imagen:
      "https://i.pinimg.com/564x/75/eb/89/75eb89c694a1eb875846dd2a2ad740cf.jpg",
  },
  {
    nombre: "Plantines y Semillas",
    imagen:
      "https://static.misionesonline.news/wp-content/uploads/2021/04/plantines-1-e1618872889935.jpg",
  },
  {
    nombre: "Composteras",
    imagen:
      "https://d22fxaf9t8d39k.cloudfront.net/e7f51cec011bb22ee4dda655b9b01f4215a0841f40d20099f70ccd602cdfa78412752.png",
  },
  {
    nombre: "Insumos y Herramientas para Huertas",
    imagen: "https://news.agrofystatic.com/huerta3_agorfy_news.jpg?d=620x375",
  },
  {
    nombre: "Lombrices Rojas Californeanas",
    imagen:
      "https://nuestraflora.com/wp-content/uploads/2019/11/Lombrices-Rojas-Californianas-6.jpg",
  },
  {
    nombre: "Servicios",
    imagen: "https://www.buenosaires.gob.ar/sites/gcaba/files/field/image/ari_mg_7488_0.jpg",
  },
];
